// extracted by mini-css-extract-plugin
export default {"bold":"TqrQ6gNRSWw3zCCauqjamg==","full":"jKzrkdF+4BC4455WUYoOhQ==","nowrap":"W7J+U5bC7JDYzT8rjLanbw==","line-clamp":"Rbkc+rkt+FIcUKuClPIJLg=="};